import React from 'react'
import List from '../crud/list'
import menuItems from '../promo-code-discounts/menuItems'

const columns = [
  { title: 'Discount', prop: 'discount_id', references: 'admin/discounts', referenceProp: 'code' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const PromoCodeDiscounts = (props) => {
  const { promoCodeId } = props.params

  return (
    <List
      title='Promo Code Discounts'
      apiPath='admin/promo_code_discounts'
      fixedFilters={{
        promo_code_id: promoCodeId
      }}
      columns={columns}
      defaults={defaults}
      buildMenuItems={menuItems}
      locationPathname={props.location.pathname}
      locationSearch={props.location.search}
      actionPathname={`/ecommerce/promo-codes/${promoCodeId}/discounts`}
    />
  )
}

export default PromoCodeDiscounts
